import React, { Component } from 'react';
import Header from '../HeaderSection/Header';
import FooterSection from "../FooterSection/Footer";
import Breadcrumb from '../Blogs/Breadcrumb';

class HeadsUpTermsAndConditions extends Component {
  state = {};

  render() {
    return (
      <div>
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        <div className="main">
          <h3 className="nav-link" style={{ marginTop: '20px' }}>
            Heads Up – Terms and Conditions of Use
          </h3>

          <h5 className="nav-link" style={{ marginTop: '20px' }}>
            Effective Date: February 5, 2026
          </h5>

          <h5 className="nav-link" style={{ marginTop: '20px' }}>End-User License Agreement (EULA)</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            Before proceeding, you must agree to the End-User License Agreement (EULA). This agreement makes it clear that there is zero tolerance for objectionable content or abusive users. By accessing or using the Heads Up mobile application, you confirm your acceptance of the EULA. If you do not agree to this EULA, you may not use the app.
          </p>

          <p className="nav-link" style={{ margin: '20px' }}>
            <strong>EULA Overview:</strong>
          </p>

          <p className="nav-link" style={{ margin: '20px' }}>
            <strong>Zero Tolerance for Objectionable Content:</strong> You must not post any content that is abusive, threatening, violent, discriminatory, or illegal. Violations will result in immediate suspension or permanent termination of your account.
          </p>

          <p className="nav-link" style={{ margin: '20px' }}>
            <strong>Abusive Users:</strong> Users found engaging in abusive behavior will be banned without notice.
          </p>

          <p className="nav-link" style={{ margin: '20px' }}>
            These Terms and Conditions of Use ("T&amp;C") govern the usage of the "Heads Up" mobile application ("the Application") provided by Moussa Harkous ("the Developer"). By accessing or using the Application, all users ("User") agree to be legally bound by these T&amp;C.
            <br /><br />
            IF YOU DO NOT ACCEPT THESE TERMS, DO NOT USE THE APPLICATION.
            <br /><br />
            The Developer reserves the right to amend these T&amp;C at any time. The most recent version of the T&amp;C governs all usage of the Application.
          </p>

          <h5 className="nav-link" style={{ marginTop: '20px' }}>Article 1: Legal Information</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The "Heads Up" Application is published by:
            <br />Moussa Harkous
            <br />Email: moussa@furrbud.com
          </p>

          <h5 className="nav-link">Article 2: Access to the Application</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The Application is accessible to all Users with an internet connection. All connection costs remain the User's responsibility.
            <br /><br />
            The Application is intended for users aged 17 and above. By using the Application, you confirm that you meet this age requirement.
            <br /><br />
            Game Modes (examples, subject to change):
            <ul>
              <li>Classic Mode — hold the phone on your forehead while friends give you clues to guess the word.</li>
              <li>Party Mode — compete in teams with timed rounds and score tracking.</li>
              <li>Categories Mode — choose from various themed card decks (movies, celebrities, animals, etc.).</li>
              <li>Custom Mode — create and manage custom word decks for personalized gameplay.</li>
            </ul>
          </p>

          <h5 className="nav-link">Article 3: Free and Premium Content</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            <strong>Free Content:</strong> Access to limited categories, basic features, and a selection of card decks.
            <br /><br />
            <strong>Premium Content:</strong> Subscribers gain access to all categories, unlimited card decks, advanced features, and ad-free experience.
            <br /><br />
            <strong>Subscription Plans:</strong>
            <ul>
              <li>Weekly: $5.99 (3-day free trial for first-time users)</li>
              <li>Monthly: $9.99</li>
              <li>Yearly: $39.99</li>
            </ul>
            Payments are processed through the user's app store account and subscriptions auto-renew unless canceled at least 24 hours before renewal. Manage subscriptions in your platform account settings.
            <br /><br />
            Trial periods must also be canceled at least 24 hours before renewal to avoid charges.
          </p>

          <h5 className="nav-link">Article 4: User Responsibilities</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            Users must adhere to all laws and these T&amp;C. Users may choose a nickname and select or upload an avatar (where supported).
            <br /><br />
            Users are solely responsible for the content they submit. When creating custom word decks or categories, users must ensure content is appropriate and does not violate any laws or these terms.
            <br /><br />
            Prohibited actions:
            <ul>
              <li>Reverse-engineering, decompiling, or tampering with the Application.</li>
              <li>Copying, redistributing, or reselling in-app content or assets.</li>
              <li>Cheating, exploiting bugs, or disrupting other players' experience.</li>
              <li>Creating or sharing inappropriate, offensive, or illegal content.</li>
            </ul>
          </p>

          <h5 className="nav-link">Article 5: Developer Rights and Liability</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The Developer may temporarily process minimal gameplay data to enable sessions (e.g., game scores, round history). Session data is removed after gameplay ends, and no personal data is retained beyond what is required for functionality or what the user explicitly saves (e.g., settings or purchases).
            <br /><br />
            The Developer is not responsible for technical issues, network failures, or discomfort arising from gameplay. Use is at the User's own risk.
          </p>

          <h5 className="nav-link">Article 6: Intellectual Property</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            All content (design, logic, assets, trademarks) in the Application belongs to Moussa Harkous or its licensors. Unauthorized reuse, duplication, or derivative works may result in legal action.
          </p>

          <h5 className="nav-link">Article 7: Updates and Service Interruption</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The Developer may modify, update, or suspend the Application at any time to add features, improve performance, or address issues. Certain features may be introduced or retired without prior notice.
          </p>

          <h5 className="nav-link">Article 8: Third-Party Links and Services</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The Application may include links or integrations with third-party services (e.g., social login, payments). The Developer is not liable for the content, policies, or availability of these external services.
          </p>

          <h5 className="nav-link">Article 9: Privacy and Data</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            The Application minimizes the collection of personal data. Information such as temporary session identifiers, game scores, device identifiers (where required for fraud prevention), player nicknames, or preferences may be processed to deliver core features. Unless explicitly saved by the user (e.g., purchases, settings), session information is discarded after use.
            <br /><br />
            For more details on data handling or to make a privacy request, contact the Developer at the email below.
          </p>

          <h5 className="nav-link">Article 10: Duration</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            These terms are valid indefinitely from the User's first use of the Application and remain in effect until updated or replaced by a newer version.
          </p>

          <h5 className="nav-link">Article 11: Contact and Support</h5>
          <p className="nav-link" style={{ margin: '20px' }}>
            For support or feedback, please contact:
            <br />Moussa Harkous
            <br />moussa@furrbud.com
            <br />+96178912776
          </p>

          <h5 className="nav-link">Thank you for playing Heads Up!</h5>
        </div>
      </div>
    );
  }
}

export default HeadsUpTermsAndConditions;
